<script>
  import Page from '@components/page.svelte'
  import Image from '@components/general/image.svelte'
  import Text from '@components/general/text.svelte'
  import Button from '@components/buttons/button.svelte'
  import Empty from '@components/general/empty.svelte'
  import { Users, Settings } from 'lucide-svelte'

  let { contributors = [] } = $props()

  let pageProps = {
    pageTitle: "Our Contributors",
    title: "Our Contributors",
    subtitle: "Meet the people behind the content",
    Icon: Users,
    adminActions: [
      { text: "Manage", path: "/admin/contributors", icon: Settings }
    ]
  }
</script>

<Page {...pageProps}>
  
  <div class="flex flex-wrap gap-4">
    {#each contributors as contributor (contributor.id)}
      <Button variant="naked" path={`/contributors/${contributor.id}`} class="flex flex-col items-center gap-3 group rounded-md ring-1 ring-gray-200/80 hover:ring-gray-300 ring-offset-2 p-5 w-48 transition-all">

        <!-- Avatar -->
        <Image
          src={contributor.card_image}
          alt={contributor.name}
          text={contributor.name?.charAt(0)}
          class="w-24 h-24 rounded-full object-cover border border-gray-200/70 bg-gray-100 text-gray-400 text-xl shadow-sm"
        />

        <!-- Name & role -->
        <div class="flex flex-col items-center gap-1 text-center">
          <Text variant="section_title" text={contributor.name} />
          <span class="text-gray-500 text-sm">{contributor.role || 'Contributor'}</span>
        </div>

      </Button>
    {:else}
      <Empty message="No contributors found" />
    {/each}
  </div>

</Page>
